import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { CLUB } from "@/data/content";

const VALUES = [
  "Passione nerazzurra e amicizia",
  "Aggregazione per il territorio molisano",
  "Trasferte organizzate verso San Siro",
  "Eventi e cene sociali",
];

export default function ChiSiamo() {
  return (
    <section id="chi-siamo" data-testid="chi-siamo-section" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="rounded-3xl overflow-hidden border border-border shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1693517382976-20ef824a9c7c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                alt="Tifosi nerazzurri"
                className="w-full h-[420px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 md:right-6 rounded-2xl bg-primary text-primary-foreground px-6 py-4 shadow-xl">
              <p className="font-bebas text-3xl leading-none">Dal {CLUB.founded}</p>
              <p className="text-xs font-semibold uppercase tracking-widest">nel cuore del Molise</p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="text-xs font-bold uppercase tracking-widest text-primary">Chi Siamo</span>
            <h2 className="mt-3 font-display font-extrabold uppercase tracking-tight text-3xl md:text-4xl">
              Una famiglia nerazzurra a Guardialfiera
            </h2>
            <div className="mt-5 space-y-4 text-muted-foreground leading-relaxed font-medium">
              <p>
                L'<strong className="text-foreground">Inter Club Guardialfiera</strong> nasce dalla passione di un gruppo di
                amici e tifosi dell'FC Internazionale, nel piccolo borgo di Guardialfiera, affacciato sul lago del Liscione,
                in provincia di Campobasso.
              </p>
              <p>
                Da allora siamo cresciuti fino a diventare un punto di riferimento per gli interisti del Molise, un luogo dove
                la passione per i colori nerazzurri diventa condivisione, amicizia e appartenenza.
              </p>
              <p>
                Organizziamo trasferte in pullman verso San Siro, eventi, iniziative e momenti di aggregazione che coinvolgono
                tifosi di tutte le età, creando occasioni per vivere insieme l'emozione dell'Inter, dentro e fuori dallo stadio.
              </p>
              <p>
                Il nostro obiettivo è continuare a far crescere questa grande famiglia nerazzurra, portando avanti i valori
                dell'Inter e rafforzando il legame tra il nostro territorio e i colori che amiamo.
              </p>
            </div>

            <ul className="mt-6 grid sm:grid-cols-2 gap-3">
              {VALUES.map((v) => (
                <li key={v} className="flex items-start gap-2 text-sm font-semibold">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold text-[#0B0E14]">
                    <Check size={13} strokeWidth={3} />
                  </span>
                  {v}
                </li>
              ))}
            </ul>

            <button
              data-testid="chi-siamo-more-btn"
              onClick={() => document.querySelector("#tesseramento")?.scrollIntoView({ behavior: "smooth" })}
              className="mt-8 inline-flex rounded-full bg-primary px-6 py-3 font-bold uppercase tracking-wide text-primary-foreground hover:bg-primary/90 transition-colors"
            >
              Unisciti al club
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
